/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

import colors from "assets/theme-dark/base/colors";
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { white, text, secondary, warning, primary } = colors;

const iconSize = (px) => ({
  "& .material-icons, & .material-icons-round, & svg": {
    fontSize: pxToRem(px),
  },
});

const contained = {
  base: {
    backgroundColor: white.main,
    minHeight: pxToRem(40),
    color: text.main,
    padding: `0 ${pxToRem(20)}`,
    "&:hover": {
      backgroundColor: white.main,
    },
    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
    },
    ...iconSize(18),
  },

  small: {
    minHeight: pxToRem(32),
    padding: `0 ${pxToRem(14)}`,
    fontSize: pxToRem(12),
    ...iconSize(16),
  },

  large: {
    minHeight: pxToRem(48),
    padding: `0 ${pxToRem(24)}`,
    fontSize: pxToRem(14),
    ...iconSize(20),
  },

  primary: {
    backgroundColor: primary.main,
    "&:hover": {
      backgroundColor: primary.main,
    },
    "&:focus:not(:hover)": {
      backgroundColor: primary.focus,
    },
  },

  warning: {
    backgroundColor: warning.main,
    "&:hover": {
      backgroundColor: warning.main,
    },
    "&:focus:not(:hover)": {
      backgroundColor: warning.focus,
    },
  },

  secondary: {
    backgroundColor: secondary.main,
    "&:hover": {
      backgroundColor: secondary.main,
    },
    "&:focus:not(:hover)": {
      backgroundColor: secondary.focus,
    },
  },
};

export default contained;
